import { isEqual } from "lodash";

import { useMemo } from "react";

import { getOptionCheckedText, getRadioCheckedText } from "@/utils/filter";

import { useFilterContext } from "../FilterContext";
import { FilterData } from "../typing";
import { MaxPointsSliderSort } from "../utils/constants";

/**
 * 用于回显选中的filterButton
 * @returns
 */
const useFilterChecked = () => {
  const { filterData, filterOptions, defaultFilterData } = useFilterContext();
  return useMemo(() => {
    const filterCheckedMap: Record<string, string> = {};

    const isDefault = (key: keyof FilterData) => {
      return isEqual(defaultFilterData[key], filterData[key]);
    };

    const filterOptionsMap = {
      programs: filterOptions.programsOptions,
      banks: filterOptions.banksOptions,
      cabins: filterOptions.cabinsOptions,
      nonStop: filterOptions.cabinsOptions,
      lastSeenTime: filterOptions.lastSeenRangeTime,
      airlines: filterOptions.airlinesOptions,
    };

    for (const key of Object.keys(filterData)) {
      switch (key) {
        case "programs":
        case "cabins":
        case "nonStop":
        case "banks": {
          filterCheckedMap[key] = isDefault(key)
            ? ""
            : getOptionCheckedText(filterOptionsMap[key], filterData[key]);
          break;
        }

        case "airlines": {
          filterCheckedMap[key] = getOptionCheckedText(
            filterOptionsMap[key],
            filterData["airlines"].concat(filterData["excludeAirlines"])
          );
          break;
        }
        case "maxPoints": {
          const res = filterData[key]
            .map((v, i) => {
              if (v === -1) {
                return "";
              }
              return MaxPointsSliderSort[i];
            })
            .filter(Boolean);
          const d = res.length > 1 ? `${res[0]} +${res.length - 1}` : res[0];
          filterCheckedMap[key] = isDefault(key) ? "" : d;
          break;
        }

        case "premium": {
          const res = Math.max(...filterData[key]);
          filterCheckedMap[key] = isDefault(key) ? "" : `${key}: >=${res}%`;
          break;
        }

        case "seats": {
          const res = Math.max(...filterData[key]);
          filterCheckedMap[key] = isDefault(key) ? "" : `${key}: ${res}+`;
          break;
        }

        case "tax":
          filterCheckedMap[key] = isDefault(key) ? "" : `${key}: $${filterData[key]}`;
          break;

        case "lastSeenTime":
          filterCheckedMap[key] = isDefault(key)
            ? ""
            : getRadioCheckedText(filterOptionsMap[key], filterData[key]);
          break;

        default:
          break;
      }
    }

    return filterCheckedMap;
  }, [filterData, filterOptions, defaultFilterData]);
};

export default useFilterChecked;
